import { createSlice } from "@reduxjs/toolkit";

interface Role {
    id: number;
    /**
     * Del endpoint `/api/roles/dropdown` `name` llega como la etiqueta legible
     * (español) y `code` como el código técnico (ADMIN, ...). De `/api/roles`
     * (`RoleWithPermissionsDTO`) `name` es el código y `label` la etiqueta.
     */
    name: string;
    code?: string;
    label?: string;
}

export const initialStateForm: Role = {
    id: 0,
    name: '',
};

export interface DropdownState {
    dropdownOptions: Role[];
}

export const initialState: DropdownState = {
    dropdownOptions: [],
};

export const roleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        setDropdownOptions: (state, action) => {
            state.dropdownOptions = action.payload;
        },
    }
});

export const { setDropdownOptions } = roleSlice.actions;

export default roleSlice.reducer;